import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Snackbar,
  TextField
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { makeStyles } from '@mui/styles';
import { ReactComponent as CheckBoxOutlineIcon } from '../../../icons/checkBoxOutlineIcon.svg';
import { ReactComponent as CheckedIcon } from '../../../icons/checkBoxIcon.svg';
import { useAuth } from '../../customContextProviders/AuthContext';
import SwitchButton from './SwitchButton';
import { LowBatteryThresholdRange, PsmFrequencyData } from '../../../utils/Utilities';
import {
  GetOrganizationDetailById,
  UpdateOrganizationDevicesSetting
} from '../../../network/Organization';

const useStyles = makeStyles((theme) => ({
  customDashCard: {
    background: '#FFFFFF',
    boxShadow: '10px 10px 19px 1px #EAEAFF',
    borderRadius: '20px',
    minHeight: '190px'
  },
  textStyle: {
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '18px',
    textAlign: 'left',
    color: '#7c7d7d'
  },
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  }
}));

export default function ControlCenter({ alertMetas, setAlertMetas }) {
  const { sessionUserData } = useAuth();

  const { organization } = sessionUserData?.user || {};

  const classes = useStyles();
  const unlockChannelMethods = ['Dashboard', 'RFID', 'SMS'];

  const [listDense, setListDense] = useState(false);
  const [controlCenterDeviceSetting, setControlCenterDeviceSetting] = useState({});

  const [controlCenterSetting, setControlCenterSetting] = useState({
    delayedTripThreshold: 0,
    lowBatteryThreshold: 0,
    geoFenceRadius: 0,
    notificationFrequency: 0,
    isShipmentDelayAllowed: false,
    vipNumbers: [],
    selectedUnlockChannel: ['Dashboard', 'RFID', 'SMS'],
    unlock_channel_MQTT: true,
    unlock_channel_SMS: true,
    unlock_channel_RFID: true,
    isPowerSwitchEnabled: false,
    psm_freq: 0
    // password: ''
  });

  const [vipNumberError, setVipNumberError] = useState(false);
  const [vipLengthError, setVipLengthError] = useState(false);

  const getHelperText = () => {
    if (vipNumberError) return 'You can add only up to 4 numbers.';
    if (vipLengthError) return 'Invalid number';
    return '';
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setControlCenterSetting({ ...controlCenterSetting, [name]: value });
  };
  const handleSwitchStatus = (e, name) => {
    setControlCenterSetting({ ...controlCenterSetting, [name]: e.target.checked });
  };

  const getOrganizationData = async () => {
    try {
      const res = await GetOrganizationDetailById(organization?.id);
      if (res) {
        setControlCenterDeviceSetting(res?.data?.data);
      }
    } catch (error) {
      console.log(error, 'err');
    }
  };

  const saveControlCenterSetting = async () => {
    const payload = {
      email: controlCenterDeviceSetting.email,
      name: controlCenterDeviceSetting.name,
      address: controlCenterDeviceSetting.address,
      phone: controlCenterDeviceSetting.phone,
      isActive: controlCenterDeviceSetting.isActive,
      countryCode: controlCenterDeviceSetting.countryCode,
      settings: {
        delayedTripThreshold: Number(controlCenterSetting.delayedTripThreshold),
        isShipmentDelayAllowed: controlCenterSetting.isShipmentDelayAllowed,
        geoFenceRadius: Number(controlCenterSetting.geoFenceRadius),
        password: 'Proxgy@1234',
        vipNumbers: controlCenterSetting.vipNumbers,
        lowBatteryThreshold: controlCenterSetting.lowBatteryThreshold,
        notificationFrequency: Number(controlCenterSetting.notificationFrequency),
        fwVersion: controlCenterDeviceSetting?.settings?.fwVersion,
        communicationMode: controlCenterDeviceSetting?.settings?.communicationMode,
        psm_freq: controlCenterSetting.psm_freq,
        normal_mode: controlCenterDeviceSetting?.settings?.normal_mode,
        standby_mode: controlCenterDeviceSetting?.settings?.standby_mode,
        unlock_channel_MQTT: controlCenterSetting.unlock_channel_MQTT,
        unlock_channel_SMS: controlCenterSetting.unlock_channel_SMS,
        unlock_channel_RFID: controlCenterSetting.unlock_channel_RFID,
        isPowerSwitchEnabled: controlCenterSetting.isPowerSwitchEnabled,
        mqtt_host: controlCenterDeviceSetting?.settings?.mqtt_host,
        mqtt_port: controlCenterDeviceSetting?.settings?.mqtt_port,
        mqtt_username: controlCenterDeviceSetting?.settings?.mqtt_username,
        mqtt_password: controlCenterDeviceSetting?.settings?.mqtt_password,
        passwordHash: controlCenterDeviceSetting?.settings?.passwordHash
      }
    };

    try {
      const res = await UpdateOrganizationDevicesSetting(organization?.id, payload);
      if (res) {
        setAlertMetas({
          ...alertMetas,
          severity: 'success',
          snackBarOpened: true,
          msg: 'Settings Updated Successfully !!'
        });
        setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
      }
    } catch (error) {
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: error?.response?.data?.message
      });
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
    }
  };

  useEffect(() => {
    if (organization?.id) {
      getOrganizationData();
    }
  }, [organization?.id]);

  useEffect(() => {
    if (controlCenterDeviceSetting) {
      const selectedChannels = [];
      if (controlCenterDeviceSetting?.settings?.unlock_channel_MQTT)
        selectedChannels.push('Dashboard');
      if (controlCenterDeviceSetting?.settings?.unlock_channel_SMS) selectedChannels.push('SMS');
      if (controlCenterDeviceSetting?.settings?.unlock_channel_RFID) selectedChannels.push('RFID');
      setControlCenterSetting({
        delayedTripThreshold: controlCenterDeviceSetting?.settings?.delayedTripThreshold,
        lowBatteryThreshold: controlCenterDeviceSetting?.settings?.lowBatteryThreshold,
        geoFenceRadius: controlCenterDeviceSetting?.settings?.geoFenceRadius,
        notificationFrequency: controlCenterDeviceSetting?.settings?.notificationFrequency,
        isShipmentDelayAllowed: controlCenterDeviceSetting?.settings?.isShipmentDelayAllowed,
        vipNumbers: controlCenterDeviceSetting?.settings?.vipNumbers || [],
        selectedUnlockChannel: selectedChannels,
        isPowerSwitchEnabled: controlCenterDeviceSetting?.settings?.isPowerSwitchEnabled,
        psm_freq: controlCenterDeviceSetting?.settings?.psm_freq
      });
    }
  }, [controlCenterDeviceSetting]);

  useEffect(() => {
    setControlCenterSetting((prevState) => ({
      ...prevState,
      unlock_channel_RFID: controlCenterSetting?.selectedUnlockChannel.includes('RFID'),
      unlock_channel_MQTT: controlCenterSetting?.selectedUnlockChannel.includes('Dashboard'),
      unlock_channel_SMS: controlCenterSetting?.selectedUnlockChannel.includes('SMS')
    }));
  }, [controlCenterSetting.selectedUnlockChannel]);

  return (
    <>
      <List
        dense={listDense}
        sx={{
          p: 0
        }}
      >
        <ListItem
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'flex-start',
            gap: 1,
            backgroundColor: '#F8F8FA'
          }}
        >
          <ListItemText
            primary="Unlock Channel"
            sx={{ mt: { xs: 0, sm: 1 } }}
            primaryTypographyProps={{ fontSize: { xs: '12px', sm: '14px' } }}
          />
          <FormControl
            data-testid="unlock-channel-controlcenter"
            size="small"
            sx={{ minWidth: { xs: '45vw', sm: '25vw', md: '14.5vw' } }}
          >
            <Select
              sx={{ fontSize: '12px', fontWeight: '500' }}
              labelId="unlock-channel-multiple-chip-label"
              id="unlock-channel-multiple-chip"
              multiple
              name="selectedUnlockChannel"
              size="small"
              value={controlCenterSetting.selectedUnlockChannel}
              onChange={handleChange}
              IconComponent={ExpandMoreIcon}
              input={<OutlinedInput id="selectedDevice-multiple-chip" />}
              renderValue={(selected) => selected.join(', ')}
            >
              {unlockChannelMethods.map((type) => (
                <MenuItem
                  key={type}
                  value={type}
                  sx={{
                    m: 1,
                    p: 0,
                    fontSize: { xs: '12px', sm: '14px' },
                    '&:hover': {
                      backgroundColor: 'transparent'
                    },
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                      '&:hover': {
                        backgroundColor: 'transparent'
                      }
                    },
                    '&:focus': {
                      backgroundColor: 'transparent'
                    },
                    '&.Mui-selected.Mui-focusVisible': {
                      backgroundColor: 'transparent'
                    }
                  }}
                  disableRipple
                  className={classes.menuItem}
                >
                  <Checkbox
                    checked={controlCenterSetting.selectedUnlockChannel.includes(type)}
                    size="small"
                    icon={
                      CheckBoxOutlineIcon ? (
                        <CheckBoxOutlineIcon style={{ height: '12px', width: '12px' }} />
                      ) : null
                    }
                    checkedIcon={
                      CheckedIcon ? <CheckedIcon style={{ height: '12px', width: '12px' }} /> : null
                    }
                  />
                  <ListItemText
                    primary={type}
                    sx={{
                      fontSize: { xs: '12px', sm: '14px' },
                      '& .MuiTypography-root': {
                        fontSize: { xs: '12px', sm: '14px' },
                        fontWeight: 400
                      }
                    }}
                  />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </ListItem>

        <ListItem
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'flex-start',
            gap: 1,
            backgroundColor: '#FFFFFF'
          }}
        >
          <ListItemText
            primary="Low battery alarm limit"
            secondary="Set minimum percentage (%) of battery at which the alarm is raised."
            primaryTypographyProps={{ fontSize: { xs: '12px', sm: '14px' } }}
            secondaryTypographyProps={{ fontSize: { xs: '12px', sm: '14px' } }}
          />
          <FormControl
            data-testid="low-battery-alarm"
            size="small"
            sx={{ minWidth: { xs: '30vw', sm: '14.5vw' } }}
          >
            <Select
              sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: '500' }}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              size="small"
              name="lowBatteryThreshold"
              value={controlCenterSetting.lowBatteryThreshold}
              onChange={handleChange}
              IconComponent={ExpandMoreIcon}
            >
              {LowBatteryThresholdRange?.map((item) => (
                <MenuItem key={item} className={classes.menuItem} value={item}>
                  {item} %
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </ListItem>

        <ListItem
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'flex-start',
            gap: 1,
            bgcolor: '#F8F8FA'
          }}
        >
          <ListItemText
            primary="GeoFence radius"
            secondary="Set the radius to anywhere between 10 - 10,000m"
            primaryTypographyProps={{ fontSize: { xs: '12px', sm: '14px' } }}
            secondaryTypographyProps={{ fontSize: { xs: '12px', sm: '14px' } }}
          />
          <TextField
            size="small"
            variant="outlined"
            type="number"
            name="geoFenceRadius"
            sx={{
              minWidth: '14.5vw',
              '& .MuiInputBase-input': {
                fontSize: { xs: '12px', sm: '14px' } // Small screen: 12px, Larger screens: 14px
              }
            }}
            value={controlCenterSetting.geoFenceRadius}
            onChange={handleChange}
            InputProps={{
              endAdornment: <InputAdornment position="end">m</InputAdornment>,
              inputProps: { min: 10, max: 10000 }
            }}
          />
        </ListItem>

        <ListItem
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 1,
            backgroundColor: '#FFFFFF'
          }}
        >
          <Box sx={{ display: 'flex' }}>
            <SwitchButton
              inputProps={{ 'aria-label': 'ant design', 'data-testid': 'switch-check-box' }}
              handleChange={(e) => handleSwitchStatus(e, 'isShipmentDelayAllowed')}
              value={controlCenterSetting.isShipmentDelayAllowed}
              fontSize={{ xs: '12px', sm: '14px' }}
            />
            <ListItemText
              sx={{ pl: 2 }}
              primary="Shipment delay allowance "
              secondary="Set the minimum time of delay between 30-1440 mins  at which the alarm is raised."
              primaryTypographyProps={{ fontSize: { xs: '12px', sm: '14px' } }}
              secondaryTypographyProps={{ fontSize: { xs: '12px', sm: '14px' } }}
            />
          </Box>

          <TextField
            size="small"
            variant="outlined"
            type="number"
            name="delayedTripThreshold"
            sx={{
              minWidth: '14.5vw',
              '& .MuiInputBase-input': {
                fontSize: { xs: '12px', sm: '14px' }
              }
            }}
            value={controlCenterSetting.delayedTripThreshold}
            onChange={handleChange}
            InputProps={{
              endAdornment: <InputAdornment position="end">mins</InputAdornment>,
              inputProps: { min: 30, max: 1440 }
            }}
            disabled={!controlCenterSetting.isShipmentDelayAllowed}
          />
        </ListItem>

        <ListItem
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'flex-start',
            gap: 1,
            bgcolor: '#F8F8FA'
          }}
        >
          <ListItemText
            primary="Server Data Update Frequency"
            secondary="Set the server data update frequency between 30sec - 21600sec"
            primaryTypographyProps={{ fontSize: { xs: '12px', sm: '14px' } }}
            secondaryTypographyProps={{ fontSize: { xs: '12px', sm: '14px' } }}
          />
          <TextField
            size="small"
            variant="outlined"
            type="number"
            sx={{
              minWidth: '14.5vw',
              '& .MuiInputBase-input': {
                fontSize: { xs: '12px', sm: '14px' }
              }
            }}
            name="notificationFrequency"
            value={controlCenterSetting.notificationFrequency}
            onChange={handleChange}
            InputProps={{
              endAdornment: <InputAdornment position="end">sec</InputAdornment>,
              inputProps: { min: 30, max: 21600 }
            }}
          />
        </ListItem>

        <ListItem
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'flex-start',
            gap: 1,
            backgroundColor: '#FFFFFF'
          }}
        >
          <ListItemText
            primary="PSM Frequency"
            secondary="Set the Power Saving Mode data update frequency between 5min - 7 days"
            primaryTypographyProps={{ fontSize: { xs: '12px', sm: '14px' } }}
            secondaryTypographyProps={{ fontSize: { xs: '12px', sm: '14px' } }}
          />
          <FormControl size="small">
            <Select
              size="small"
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              sx={{ minWidth: { xs: '30vw', sm: '14.5vw' }, fontSize: { xs: '12px', sm: '14px' } }}
              name="psm_freq"
              value={controlCenterSetting.psm_freq}
              onChange={handleChange}
              IconComponent={ExpandMoreIcon}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 180,
                    overflowY: 'auto'
                  }
                }
              }}
            >
              {PsmFrequencyData?.map((item) => (
                <MenuItem key={item?.value} value={item?.value} className={classes.menuItem}>
                  {item?.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </ListItem>
        <ListItem
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'flex-start',
            gap: 1,
            backgroundColor: '#F8F8FA'
          }}
        >
          <ListItemText
            primary="VIP Numbers"
            sx={{ mt: { xs: 0, sm: 1 } }}
            primaryTypographyProps={{ fontSize: { xs: '12px', sm: '14px' } }}
          />
          <Autocomplete
            multiple
            size="small"
            sx={{
              minWidth: { xs: '30vw', sm: '14.5vw' },
              fontSize: { xs: '12px', sm: '14px' },
              fontWeight: '500'
            }}
            id="tags-filled"
            options={[]}
            freeSolo
            name="vipNumbers"
            value={controlCenterSetting.vipNumbers}
            onChange={(_, value, reason) => {
              if (reason === 'remove-option') {
                setVipNumberError(false);
                setVipLengthError(false);
              }
              const filteredValues = value.filter((val) => /^\d{10}$/.test(val));

              if (filteredValues.length > 4) {
                setVipNumberError(true);
                return;
              }
              if (value.length > 0 && !/^\d{10}$/.test(value[value.length - 1])) {
                setVipLengthError(true);
                return;
              }

              setVipLengthError(false);
              setVipNumberError(false);
              setControlCenterSetting({
                ...controlCenterSetting,
                vipNumbers: filteredValues
              });
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => {
                const { key, ...tagProps } = getTagProps({ index });
                return (
                  <Chip
                    variant="outlined"
                    size="small"
                    sx={{ fontSize: { xs: '12px', md: 'inherit' } }}
                    label={option}
                    key={key}
                    {...tagProps}
                  />
                );
              })
            }
            renderInput={(params) => (
              <TextField
                type="number"
                size="small"
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: { xs: '12px', sm: '14px' } // Adjust the font size for input
                  }
                }}
                {...params}
                inputProps={{
                  ...params.inputProps,
                  'data-testid': 'vip-numbers-input'
                }}
                error={vipNumberError || vipLengthError}
                helperText={getHelperText()}
              />
            )}
          />
        </ListItem>
      </List>
      <Box sx={{ width: '100%', p: 3, textAlign: 'center' }}>
        <Button
          variant="contained"
          size="medium"
          color="primary"
          sx={{ boxShadow: 'none' }}
          onClick={saveControlCenterSetting}
        >
          SAVE
        </Button>
      </Box>
    </>
  );
}
